const object = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : {};
const array = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try { return array(JSON.parse(value)); } catch { return []; }
  }
  return [];
};
const firstObject = (value) => object(Array.isArray(value) ? value[0] : value);
const hasProduct = (value) => value && typeof value === "object" &&
  ["title", "name", "product_name", "product_variant_id", "product_id"].some((key) => value[key] !== null && value[key] !== undefined && value[key] !== "");
const imageUrl = (image) => typeof image === "string" ? image : image?.image || image?.url || image?.image_url || "";

export const getProductDetailsData = (response) => {
  const data = firstObject(response?.data);
  const source = [data.product_details, data.product_detail, data.product, data.response_data, data.cell_contents, data]
    .map(firstObject).find(hasProduct);
  if (!source) return { product: null, recommendations: null };

  const detail = { ...object(source.product), ...source };
  const images = [detail.images, detail.product_images, detail.gallery, Array.isArray(detail.image) ? detail.image : null]
    .map(array).find((items) => items.length > 0) || [];
  const summary = object(detail.review_summary || data.review_summary || data.rating_summary);
  const product = {
    ...detail,
    title: detail.title || detail.name || detail.product_name,
    images: images.map(imageUrl).filter(Boolean),
    image: typeof detail.image === "string" ? detail.image : detail.product_image || images.map(imageUrl).find(Boolean),
    portions: array(detail.portions),
    review_summary: {
      ...summary,
      rating: summary.rating ?? summary.average_rating ?? detail.average_rating ?? detail.rating ?? 0,
      count: summary.count ?? summary.total_reviews ?? detail.review_count ?? detail.total_reviews ?? 0,
      distribution: summary.distribution || summary.rating_distribution || {},
    },
  };
  const recommendations = data.recommended_products || data.related_products || data.related_items || detail.recommended_products || detail.related_products || null;
  const items = Array.isArray(recommendations) ? recommendations
    : array(recommendations?.cell_contents || recommendations?.products || recommendations?.items);

  return { product, recommendations: items.length ? {
    ...object(recommendations), cell_title_text: recommendations?.cell_title_text || "Recommended for you", cell_contents: items,
  } : null };
};
